import { useState } from 'react';
import { Modal, Button, Stack, TextInput, Radio, Group, FileInput, Text } from '@mantine/core';
import { IconFileText, IconLink, IconPlus } from '@tabler/icons-react';
import { notifyError } from './Toast'; // si no lo tenés, cámbialo por tu helper de notificaciones

const ModalAttachment = ({ opened, onClose, onConfirm, disabled = false }) => {
  const [tipo, setTipo] = useState('url'); // 'url' | 'archivo'
  const [url, setUrl] = useState('');
  const [file, setFile] = useState(null);
  const [descripcion, setDescripcion] = useState('');

  const reset = () => {
    setTipo('url');
    setUrl('');
    setFile(null);
    setDescripcion('');
  };

  const validate = () => {
    if (disabled) return 'Alcanzaste el límite de anexos';
    if (!descripcion.trim()) return 'Debe completar la descripción del anexo';
    if (descripcion.length > 200) return 'La descripción no puede tener más de 200 caracteres';

    if (tipo === 'url') {
      if (!url) return 'Debe completar la URL';
      try {
        // valida formato de URL
        new URL(url);
      } catch {
        return 'La URL del anexo no es válida';
      }
    } else {
      if (!file) return 'Debe seleccionar un archivo';
    }
    return null;
  };

  const handleConfirm = () => {
    const err = validate();
    if (err) {
      notifyError ? notifyError(err) : alert(err);
      return;
    }

    const nuevoAnexo =
      tipo === 'url'
        ? {
            id: Date.now(),
            tipo: 'url',
            valor: url,
            nombre: url,
            descripcion: descripcion.trim(),
          }
        : {
            id: Date.now(),
            tipo: 'archivo',
            valor: file,
            nombre: file.name,
            descripcion: descripcion.trim(),
          };

    onConfirm(nuevoAnexo);
    reset();
  };

  return (
    <Modal opened={opened} onClose={() => { reset(); onClose(); }} title="Agregar anexo" centered size="lg">
      <Stack gap="md">
        <Radio.Group label="Tipo de anexo" value={tipo} onChange={setTipo}>
          <Group mt="xs">
            <Radio value="url" label="URL" />
            <Radio value="archivo" label="Archivo" />
          </Group>
        </Radio.Group>

        {tipo === 'url' ? (
          <TextInput
            label="URL del anexo"
            placeholder="https://ejemplo.com/documento.pdf"
            value={url}
            onChange={(e) => setUrl(e.currentTarget.value)}
            leftSection={<IconLink size={16} />}
          />
        ) : (
          <FileInput
            label="Archivo anexo"
            placeholder="Selecciona un archivo"
            value={file}
            onChange={setFile}
            accept=".pdf,.jpg,.jpeg,.png"
            leftSection={<IconFileText size={16} />}
          />
        )}

        <TextInput
          label="Descripción del anexo"
          placeholder="Describe brevemente el contenido o propósito de este anexo"
          value={descripcion}
          onChange={(e) => setDescripcion(e.currentTarget.value)}
          required
          maxLength={200}
        />

        <Group justify="flex-end" mt="sm">
          <Button variant="default" onClick={() => { reset(); onClose(); }}>
            Cancelar
          </Button>
          <Button leftSection={<IconPlus size={16} />} onClick={handleConfirm} disabled={disabled}>
            Agregar
          </Button>
        </Group>

        {disabled && (
          <Text size="xs" c="red">
            Límite de anexos alcanzado (3/3)
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default ModalAttachment;
